import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const legendLabelColor = '#777c83'


const RaddarChart = ({
    chartData = [],
    chartLabel,
    fieldsLabel = "",
    purpose = "",
    legendLabel = "Average Slippage",
}) => {

    // Dummy data for testing
    const dummyData = [
        {
            departmentName: "Product",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "Marketing",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "Operation",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "Sales",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "HR",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "Information Technology",
            avgSlippage: '-',
            totalTasks: '-',
        },
        {
            departmentName: "Finance and accounts",
            avgSlippage: '-',
            totalTasks: '-',
        }
    ];

    const graphData =
        chartData && chartData.length > 0
            ? chartData
            : dummyData;

    const maxValue =
        Math.max(
            ...graphData?.map(item => item.avgSlippage)
        ) + 500;

    const option = {
        tooltip: {
            trigger: "item",
            formatter: (params) => {
                const item = graphData[params.dataIndex];
                return `
            ${purpose ? `<b>Purpose</b><br/>${purpose}<br/><br/>` : ""}
            <b>${item.departmentName}</b><br/>
            <b>Average Slippage</b> : ${item.avgSlippage}<br/>
            <b>Total Tasks</b> : ${item.totalTasks}
        `;
            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            data: [legendLabel],
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        radar: {
            radius: "65%",
            center: ["50%", "55%"],
            splitNumber: 5,
            indicator: graphData?.map(item => ({
                name: item.departmentName,
                max: maxValue,
            })),

            axisName: {
                color: "#374151",
                fontSize: 13,
                fontWeight: 600,
            },

            splitArea: {
                areaStyle: {
                    color: [
                        "#FFFFFF",
                        "#FAFAFA",
                    ],
                },
            },

            splitLine: {
                lineStyle: {
                    color: "#E5E7EB",
                },
            },

            axisLine: {
                lineStyle: {
                    color: "#D1D5DB",
                },
            },
        },
        series: [
            {
                type: "radar",
                data: [
                    {
                        value: graphData.map(item => item.avgSlippage),
                        name: legendLabel,

                        areaStyle: {
                            color: "rgba(139,92,246,.35)",
                        },

                        lineStyle: {
                            color: "#8B5CF6",
                            width: 3,
                        },

                        itemStyle: {
                            color: "#8B5CF6",
                        },
                    },
                ],
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={420}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default RaddarChart;
